// Emailed links, read the way they were actually sent (2026-10-12, BES).
//
// Digests sent before the fix carried `...&activity=X?ml=TOKEN` - a second
// '?' - so URLSearchParams saw no `ml` at all and `activity` came back as
// "X?ml=TOKEN". Those mails are still in inboxes; read the token wherever it
// sits and drop it from every value.

export function magicTokenFromSearch(search) {
  const m = String(search || "").match(/[?&]ml=([^&#?]+)/);
  if (!m) return "";
  try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
}

// The query string with every ml= removed ('' or '?a=b&c=d').
export function searchWithoutMagic(search) {
  const s = String(search || "").replace(/^\?/, "");
  const kept = s.split(/[&?]/).filter((kv) => kv && !/^ml=/.test(kv));
  return kept.length ? `?${kept.join("&")}` : "";
}

// gpt.bidlight.com embeds (back/routes/ssoGpt.js /embed): ?ge=<code> on any
// page signs that frame in with the chat user's own session.
export function embedCodeFromSearch(search) {
  const m = String(search || "").match(/[?&]ge=([a-f0-9]{64})/);
  return m ? m[1] : "";
}
export function searchWithoutEmbed(search) {
  const s = String(search || "").replace(/^\?/, "");
  const kept = s.split("&").filter((kv) => kv && !/^ge=/.test(kv));
  return kept.length ? `?${kept.join("&")}` : "";
}

// A path on this app to go to after sign-in, or '' (never another host).
export function safeNext(next) {
  const n = String(next || "").trim();
  if (!n || !n.startsWith("/") || n.startsWith("//") || n.includes("\\")) return "";
  if (/^\/(authorization)?(\?|$)/.test(n)) return "";
  const q = n.indexOf("?");
  return q >= 0 ? `${n.slice(0, q)}${searchWithoutMagic(n.slice(q))}` : n;
}

// The staging site answers a real person's sign-in with { redirect } to
// app.bidlight.com; only that host is followed.
export function followStagingRedirect(body) {
  const r = body && body.redirect;
  if (!r || !/^https:\/\/app\.bidlight\.com(\/|$)/.test(String(r))) return false;
  try { window.location.replace(r); } catch (e) { return false; }
  return true;
}
